var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadataEditNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4325 0.294511C13.6276 0.0990755 13.9452 0.0984793 14.141 0.293129L15.5504 1.69422C15.7462 1.88878 15.7473 2.20518 15.5525 2.40064L14.3475 3.607L12.2379 1.49742L11.5308 2.20453L13.6411 4.3148L8.36678 9.59876C8.30703 9.65862 8.23265 9.70226 8.15134 9.72582L5.65575 10.4481C5.50458 10.4918 5.36397 10.3519 5.40716 10.2009L6.11979 7.70808C6.14305 7.62675 6.18702 7.55257 6.24684 7.49264L13.4325 0.294511Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V13.9C14 13.9552 13.9552 14 13.9 14H2.1C2.04477 14 2 13.9552 2 13.9V2.1C2 2.04477 2.04477 2 2.1 2H8",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadataEditNameIcon);
export default __webpack_public_path__ + "static/media/metadata-edit-name-icon.11b70f26bf724f6efe329a22b456771f.svg";
export { ForwardRef as ReactComponent };